import { handleDeleteRequest, handleGetRequest, handlePostRequest, handlePutRequest } from '.';
import { URI } from '../../constants/URI';
import {
  setActiveContacts,
  setArchivedContacts,
  setBlockedContacts,
  setChatContacts,
  setContacts,
} from '../slices/contactsSlice';
import { setFilters } from '../slices/filtersSlice';
import { store } from '../store';

export const getContacts = async ({
  page,
  search,
  loading,
  netsuite_customer_id,
  assigned_user_id,
  unassigned,
  status,
  type = 'PAGE',
} = {}) => {
  const res = await handleGetRequest(URI.contacts, null, {
    toast: false,
    loading,
    params: {
      page,
      search,
      netsuite_customer_id,
      assigned_user_id,
      unassigned,
      status,
      type
    },
  });

  if (res?.ack) {
    store.dispatch(setFilters({ type }));
    if (type === 'PAGE') store.dispatch(setContacts(res));
    if (status === 2) store.dispatch(setArchivedContacts(res));
    else if (status === 0) store.dispatch(setBlockedContacts(res));
    else store.dispatch(setActiveContacts(res));
  }
  return res;
};

export const addContact = async (body) => {
  const res = await handlePostRequest(URI.contact, body);
  if (res?.ack) getContacts();
  return res;
};

export const updateContact = async (body) => {
  const res = await handlePutRequest(URI.contact, body);
  if (res?.ack) getContacts();
  return res;
};

export const deleteContact = async (body) => {
  const res = await handleDeleteRequest(URI.contact, body);
  if (res?.ack) getContacts();
  return res;
};

export const isPhoneNoExist = async (phone) => {
  const res = await handleGetRequest(URI.check_phone, null, {
    params: {
      phone,
    },
    loading: false,
  });
  return res;
};

export const getChatContacts = async ({ search, page, assigned_user_id, unassigned, unread, not_responded } = {}) => {
  const res = await handleGetRequest(URI.chat_contacts, null, {
    params: {
      search,
      page,
      assigned_user_id,
      unassigned,
      only_unread: unread,
      not_responded
    },
  });
  if (res?.ack) store.dispatch(setChatContacts(res));
  return res;
};

export const changeStatus = async (body) => {
  const res = await handlePutRequest(URI.change_status, body);
  return res;
};

export const pinnedChat = async (body) => {
  const page = store.getState().contactsSlice?.chatContactsPagination?.page
  const res = await handlePutRequest(URI.pinned_contact, body)
  if (res?.ack) getChatContacts({
    page
  })
  return res
}

export const bulkContactAssign = async (body) => {
  const res = await handlePutRequest(URI.bulk_contact_assign, body);
  return res
}